import { cn } from "@/lib/utils"

export function productAttributeValues(
  attributes?: Array<{ value?: string | null }> | null,
  fallbacks?: Array<string | null | undefined>,
): Array<{ value: string }> {
  const listed = (attributes ?? [])
    .map((item) => ({ value: (item.value || "").trim() }))
    .filter((item) => item.value)
  if (listed.length > 0) return listed
  return (fallbacks ?? [])
    .map((value) => (value || "").trim())
    .filter(Boolean)
    .map((value) => ({ value }))
}

export function ProductName({
  title,
  article,
  attributes,
  maxLength,
  className,
}: {
  title?: string | null
  article?: string | null
  attributes?: Array<{ value?: string | null }> | null
  /** Длиннее — обрезается с «…», полный текст во всплывающей подсказке. */
  maxLength?: number
  className?: string
}) {
  const name = (title || "").trim() || "—"
  const values = (attributes ?? []).map((item) => (item.value || "").trim()).filter(Boolean)
  const head = values.length > 0 ? `${name} (${values.join(", ")})` : name
  const truncated = maxLength != null && head.length > maxLength
  const art = (article || "").trim()
  return (
    <div className={cn("whitespace-normal", className)}>
      <div className="font-medium" title={truncated ? head : undefined}>
        {truncated ? `${head.slice(0, maxLength).trimEnd()}…` : head}
      </div>
      {art ? <div className="font-normal text-muted-foreground">{art}</div> : null}
    </div>
  )
}
